export default __webpack_public_path__ + "static/media/appp.86365da1.png";